import { useMemo } from "react";
import { SalesforceBundle } from "~/api/models/Bundle";
import { useFetchBundles } from "~/api/salesForce/useFetchBundles";
import { useBundles } from "./useBundles";
import useTreatmentRelatedSkinProductKeys from "./useTreatmentRelatedSkinProductKeys";
import useTreatmentType from "./useTreatmentType";

const useSkinBundles = () => {
  const { data: bundles, isLoading } = useFetchBundles();
  const { toggleBundle } = useBundles();
  const { skinCategory, skinSelected, toggleProductCategory } =
    useTreatmentType();
  const treatmentRelatedSkinProductKeys = useTreatmentRelatedSkinProductKeys();

  const highestPriceRecommendedBundle = useMemo(
    () =>
      bundles
        ?.filter((bundle) =>
          bundle.isRecommended(treatmentRelatedSkinProductKeys)
        )
        ?.reduce(
          (prev: SalesforceBundle | null, current) =>
            prev && prev.price > current.price ? prev : current,
          null
        ),
    [bundles, treatmentRelatedSkinProductKeys]
  );

  const setSkinBundleAndHandleSkinCategory = (bundle: SalesforceBundle) => {
    if (!skinSelected && skinCategory) {
      toggleProductCategory(skinCategory);
    }
    toggleBundle(bundle);
  };

  return {
    bundles,
    highestPriceRecommendedBundle,
    setSkinBundleAndHandleSkinCategory,
    isLoading,
  };
};
export default useSkinBundles;
